"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const computePayToOwnerAmount = (totalPrice, handleDepositPayment, deposit, paymentPrice) => totalPrice + (handleDepositPayment ? deposit : 0) - paymentPrice;
var _default = exports.default = computePayToOwnerAmount;